import { motion } from 'framer-motion';

interface StatisticsGridProps {
  totalMatches: number;
  wins: number;
  winRate: number;
  bestPrize: string;
  playTime: string;
  rank: number;
}

export function StatisticsGrid({
  totalMatches,
  wins,
  winRate,
  bestPrize,
  playTime,
  rank,
}: StatisticsGridProps) {
  const stats = [
    { label: 'Total Matches', value: totalMatches.toString(), icon: '🎮' },
    { label: 'Match Wins', value: wins.toString(), icon: '🏆' },
    { label: 'Win Rate', value: `${winRate}%`, icon: '📈' },
    { label: 'Best Prize', value: bestPrize, icon: '🥇' },
    { label: 'Total Play Time', value: playTime, icon: '⏱️' },
    { label: 'Leaderboard Rank', value: `#${rank}`, icon: '🏅' },
  ];

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left select-none">
      <div className="space-y-4">
        <h3 className="font-display text-sm font-black tracking-wider text-amber-300 uppercase">
          Player Statistics
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {stats.map((item, idx) => (
            <motion.div
              key={item.label}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: idx * 0.05, duration: 0.5 }}
              className="glass-light p-3.5 rounded-xl border border-white/5 flex flex-col text-left hover:border-purple-500/10 transition-colors"
            >
              <div className="flex items-center space-x-2">
                <span className="text-sm">{item.icon}</span>
                <span className="text-[8px] uppercase tracking-wider text-surface-500 font-bold">
                  {item.label}
                </span>
              </div>
              <span className="text-sm font-display font-black text-white mt-1.5 truncate">
                {item.value}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default StatisticsGrid;
